export const paypalEmail = 'info@dpsrescue.com';
export const donateEmail = 'info@dpsrescue.com';
export const donateLink = 'https://www.zeffy.com/en-US/donation-form/donate-to-change-lives-2026-giving';
export const paypalLink = 'https://www.paypal.com/donate/?hosted_button_id=JYKGZV458ZS2N#';
